export default {
  width: 8,
  offset: 2
}
